import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareCursor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareCursor"><Path d="M20.25 10.5V3.75H3.75V20.25H10.5" stroke="currentColor" strokeWidth="1.05263" strokeLinecap="square"/><Path d="M11.5 11.5L14.5 21.5L17 17L21.5 14.5L11.5 11.5Z" stroke="currentColor" strokeWidth="1.05263" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareCursor;
